import * as React from 'react';
export const bubbleSvg = React.forwardRef(function bubbleSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#121212',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M18.375 10.193c-1.798 0-3.57.771-4.922 2.288V5h-2.676v12.596a7.404 7.404 0 1 0 14.807 0c0-4.089-3.12-7.403-7.21-7.403Zm-.194 11.955a4.552 4.552 0 1 1 0-9.104 4.552 4.552 0 0 1 0 9.104Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#B9FFFF',
      d: 'M8.83 21.338a1.83 1.83 0 1 0 0 3.662 1.83 1.83 0 0 0 0-3.662Z',
    }),
  );
});
bubbleSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bubble = {
  category: 'brand',
  colorable: false,
  name: 'bubble',
  svg: bubbleSvg,
};
